import LabelMarker from "./marker-label/label-marker";

(function () {
  /**
   * BatchGeo's base tool Drawing Manager component. It sets base methods you
   * can override to alter behavior. There is two methods you *must* provide for
   * a new tool:
   *
   * - buildShape: use this to create your google maps shape you will use
   * - resizeShapeHandler: use this to handle resizing your selection and update
   *   the label text
   *
   * All other methods come with base functionality that should handle most use
   * cases for basic shapes.
   */
  var BatchGeoDrawingManagerBaseTool = {
    button: {
      class: "drawing-manager-button",
      title: "",
      order: 0,
      icon: "NOTSET",
      mode: "NOTSET",
    },

    /**
     * Enables the tool selection tool by turning the cursor into a
     * crosshairs cursor and listening for draw start, change, and end and it
     * prevents you from dragging the map around.
     *
     * @param  {object} drawingManager The BatchGeoDrawingManager instance
     * @param  {object} options        Google Maps V3 shape options
     * @return {undefined}
     */
    enable: function (drawingManager, options) {
      var self = this;
      this.options = options;
      this.drawingManager = drawingManager;
      this.prevShapes = [];

      $(document.body).addClass(
        "drawing-manager-is-selecting drawing-manager-is-selecting-" +
          drawingManager.getDrawingMode(),
      );

      // If this is true when you try to draw it'll drag/pan the map
      drawingManager.settings.map.setOptions({ draggable: false });

      BatchGeoStore.dispatch({
        type: "DRAWING_MANAGER_SELECTION_STATUS",
        status: false,
      });

      // Handle the mouse up which tracks if the user has the shift and/or the
      // control/command key pressed. We don't do an anonymous functions so that
      // we can unbind it later.
      this._onMouseUp = function (event) {
        self._isShiftDown = event.shiftKey;
        self._isCtrlDown = event.metaKey || event.ctrlKey;
      };
      // We wrap these events multiple times so that we can have the right
      // "this" context like if we did bind() or call() but be able to actually
      // unbind these events later in disable.
      this._onDrawStart = function (jqEvent, event) {
        self.drawStartHandler(event);
      };
      this._onDrawChange = function (jqEvent, event) {
        self.drawChangeHandler(event);
      };
      this._onDrawEnd = function (jqEvent, event) {
        self.drawEndHandler(event);
      };
      this._onScroll = function (event) {
        self.scrollHandler(event.originalEvent);
      };
      this._onClearMap = function () {
        self.prevShapes.forEach((shape) => {
          shape.setMap(null);
        });

        self.prevShapes = [];
        self.removeShape();
        self.removeLabel();
      };
      $(window).on("mouseup", this._onMouseUp);
      $(window).on("batchgeo.drawingmanager.start", this._onDrawStart);
      $(window).on("batchgeo.drawingmanager.change", this._onDrawChange);
      $(window).on("batchgeo.drawingmanager.end", this._onDrawEnd);
      $("#mapDiv").on("wheel", this._onScroll);
      $(window).on("batchgeo.drawingmanager.clearMap", this._onClearMap);
    },

    /**
     * Disable's the tool's selection tool by flipping the cursor back to
     * auto, letting the user drag the map around again and removing all
     * events that were setup in enable()
     *
     * @return {undefined}
     */
    disable: function () {
      $(document.body).removeClass(
        "drawing-manager-is-selecting drawing-manager-is-selecting-" +
          this.drawingManager.getDrawingMode(),
      );
      this.drawingManager.settings.map.setOptions({ draggable: true });
      BatchGeoStore.dispatch({
        type: "DRAWING_MANAGER_SELECTION_STATUS",
        status: false,
      });
      $(window).off("mouseup", this._onMouseUp);
      $(window).off("batchgeo.drawingmanager.start", this._onDrawStart);
      $(window).off("batchgeo.drawingmanager.change", this._onDrawChange);
      $(window).off("batchgeo.drawingmanager.end", this._onDrawEnd);
      $("#mapDiv").off("wheel", this._onScroll);
      $(window).off("batchgeo.drawingmanager.clearMap", this._onClearMap);

      this.clearDom();

      if (this.prevShapes.length) {
        this.prevShapes.forEach((shape) => {
          shape.setMap(null);
        });
      }

      this.prevShapes = [];
    },

    /**
     * An empty function that you need to replace with a google maps shape being
     * returned. For example, for the circle tool it returns:
     * new google.maps.Circle({...}).
     *
     * We suggest this setup so that you can alter the shape settings during the
     * initialization:
     *
     * new google.maps.SHAPENAME($.extend({ base options }, this.options)
     *
     * @return {undefined}
     */
    buildShape: function () {},

    /**
     * Creates a default label element with base styles. Returns a jQ object
     * @return {object} a jQuery element object
     */
    createLabelInstance: function () {
      return new LabelMarker({
        map: this.drawingManager.settings.map,
        position: this.startPosition,
        size: {
          width: 100,
          height: 15,
        },
      });
    },

    /**
     * getEventName function
     *
     * @param {array} selectedMarkers Array of selected markers (can be empty)
     *
     * @returns {string} DRAWING MANAGER EVENT determined by user keydown state and marker count
     */
    getEventName: function (selectedMarkers) {
      let eventName = "ROW_SELECT_SELECT";
      if (this._isShiftDown) {
        eventName = this._isCtrlDown
          ? "ROW_SELECT_DESELECT"
          : "ROW_SELECT_SELECTADD";
      } else if (selectedMarkers.length === 0) {
        eventName = "ROW_SELECT_DESELECTALL";
      }

      return eventName;
    },

    /**
     * Loops through all the selectable markers (and clusters) and removes
     * the onces that are not within the bounds of the selection the user drew.
     * Then `map()` all markers (and clusters) within the bounds to an array of
     * their correlating row index (or ID if clusters).
     *
     * @param {function} filterCallback Callack that returns a boolean indicating if resource is within selection area.
     * Must be compatible with the JS native `.filter()` method. The callback should use `getMarkerOrClusterPosition`
     * to get position of resource.
     *
     * @example
     * 	this.select((markerOrCluster) => {
     * 		return selectionBounds.contains(this.getMarkerOrClusterPosition(markerOrCluster));
     * 	})
     */
    processSelection: function (filterCallback) {
      let selectedMarkers = window.batchGeoGoogleMapsMarker
        .getMarkers()
        .filter(filterCallback);
      const eventName = this.getEventName(selectedMarkers);
      this.updateMarkerStore(
        eventName,
        selectedMarkers.map((marker) => marker.r),
      );
    },

    /**
     * Handles what happens when a selection is complete on mouseup which is
     * mainly finding which markers were in the selection. You will need to
     * override this with an appropriate approach to whichever type of tool
     * you are working on. It finally must send off a select event with the
     * selected markers.
     *
     * See the rectangle drawing tool selectionHandler for the most basic example.
     *
     * @param  {object} selection A Google Maps Rectangle object
     * @return {undefined}
     */
    selectionHandler: function () {},

    /**
     * Updates the marker store based on the events given. Supported events are:
     * - select: sets the selected markers to exactly what it is given
     *
     * - selectadd: sets the selected markers to what is given + existing
     *   selected markers
     *
     * - deselect: removes selected markers from the existing selected markers
     *
     * - deselectall: starts fresh and removes all existing selected markers
     *
     * @param  {string} eventName        String of event name to handle
     * @param  {array} [selectedMarkers] The markers to select. Required for
     * everything except deselectall
     * @return {array}                   An array of the final selected markers
     */
    updateMarkerStore: function (eventName, selectedMarkers) {
      return BatchGeoStore.dispatch({
        type: eventName,
        selectedRows: selectedMarkers,
        selectedFromDrawing: true,
      });
    },

    /**
     * Handles what happens right on mousedown before the user has event moved
     * the mouse. We cache the start LatLng and starting event and create the
     * rectangle. The rectangle will be 0px x 0px so you wont see it yet.
     *
     * @param  {object} event A JS event object containing offsetX/Y and pageX/Y
     * @return {undefined}
     */
    drawStartHandler: function (event) {
      if (!event.shiftKey) {
        this.prevShapes.forEach((shape) => {
          shape.setMap(null);
        });

        this.prevShapes = [];
      }
      // Sometimes the draw end handler might not get called for various reasons
      // so if a tool still has a map associated with it let's call the draw
      // end handler here before moving on.
      if (this.shape && this.shape.map) {
        this.removeShape();
        this.drawEndHandler(event);
      }

      this.startEvent = event;

      this.startPosition = this.drawingManager.fromEventToLatLng(event);

      this.shape = this.buildShape();
      this.removeLabel();
      this.label = this.createLabelInstance(this.startPosition);
      this.drawingManager.clearMap();
      this.drawingManager.enableMapPanning();

      BatchGeoStore.dispatch({
        type: "DRAWING_MANAGER_SELECTION_STATUS",
        status: true,
      });
    },

    /**
     * Use this to handle what happens as the selection is being moved. This is
     * different from the drawChangeHandler because the drawChangeHandler
     * handles functionality all tools have to share. Use this for functionality
     * that is specific to your tool. It will pass in the change event as the
     * first argument.
     *
     * @return {undefined}
     */
    resizeShapeHandler: function () {},

    /**
     * Handles what happens as the user drags the selection. Happens for every
     * pixel so we use this to increase the bounds (size) of the selection.
     *
     * @param  {object} event A JS event object containing offsetX/Y and pageX/Y
     * @return {undefined}
     */
    drawChangeHandler: function (event) {
      this.resizeShapeHandler(event);
    },

    /**
     * Handles what happens when the user mouses up and ends their selection.
     * Here we send the total bounds to the selectionHandler to see what markers
     * were selected and remove the tool and selection from the map.
     *
     * @param  {object} event A JS event object containing offsetX/Y and pageX/Y
     * @return {undefined}
     */
    drawEndHandler: function () {
      this.drawingManager.disableMapPanning();
      if (this.shape && this.shape.map) {
        this.selectionHandler(this.shape);
      }
      BatchGeoStore.dispatch({
        type: "DRAWING_MANAGER_SELECTION_STATUS",
        status: false,
      });
    },

    removeLabel: function () {
      this.label?.remove();
      return this;
    },

    removeShape: function () {
      this.shape?.setMap(null);
      window.BatchGeoDrawingManagerRuler.shape = null;
      return this;
    },

    clearDom: function () {
      return this.removeLabel().removeShape();
    },

    scrollHandler: function (event) {
      const map = this.drawingManager.settings.map;
      if (event.deltaY < 0) {
        map.setZoom(map.zoom + 1);
      } else if (event.deltaY > 0) {
        map.setZoom(map.zoom - 1);
      }
    },

    /**
     * If true, the shape will be left on the map after selecting. That way
     * the user can print their map with the shape still visible. Set this to false
     * for a clickable shape (like the polygon tool).
     */
    draggable: true,
  };

  window.BatchGeoDrawingManagerBaseTool = BatchGeoDrawingManagerBaseTool;
})(window);
